import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function PaymentFooter() {
  return <div className="w-full py-12 md:py-16" data-id="element-188">
      <div className="max-w-6xl mx-auto px-4" data-id="element-189">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 border-t border-gray-200 pt-8" data-id="element-190">
          <div className="flex items-center gap-2 text-gray-600 text-sm" data-id="element-191">
            <ShieldCheck className="w-5 h-5 text-laravel-red" data-id="element-192" />
            <p data-id="element-193">
              Payments are{' '}
              <strong className="text-gray-900 font-semibold" data-id="element-194">
                100% securely
              </strong>{' '}
              handled by Stripe
            </p>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-4 md:gap-6 text-gray-500 font-semibold text-base md:text-lg" data-id="element-195">
            <span className="text-blue-600 italic font-bold" data-id="element-196">VISA</span>
            <div className="flex -space-x-2" data-id="element-197">
              <div className="w-6 h-6 rounded-full bg-red-500 mix-blend-multiply" data-id="element-198"></div>
              <div className="w-6 h-6 rounded-full bg-yellow-500 mix-blend-multiply" data-id="element-199"></div>
            </div>
            <span className="text-indigo-600 font-bold tracking-tighter" data-id="element-200">
              stripe
            </span>
            <span className="flex items-center gap-1 text-gray-900" data-id="element-201">
              <span className="text-xl leading-none mb-1" data-id="element-202"></span> Pay
            </span>
            <span className="flex items-center gap-1" data-id="element-203">
              <span className="text-blue-600" data-id="element-204">G</span> Pay
            </span>
            <span className="text-blue-500 font-bold italic" data-id="element-205">PayPal</span>
          </div>
        </div>
      </div>
    </div>;
}